<template>
  <v-app id="app_authentication">

    <v-overlay v-model="centerLoading" :scrim="false" class="custom_centered_overlay">
      <v-progress-circular color="green" indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-navigation-drawer class="custom_navigation_drawer" width="30%" :image="require('@/img/background_images/image_5.png')" v-model="drawer" app></v-navigation-drawer>
    
    <v-main class="custom_border_with_small_devices custom_class_alignment">
      <v-container color="white" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" md="2"></v-col>
          <v-col cols="12" sm="12" md="8">
            <v-card flat style="background: transparent !important;">

              <!-- Title Section -->
              <template v-slot:title>
                <v-card-title class="custom_topic_sign_in text-wrap" style="white-space: normal;">
                  Enter otp code
                </v-card-title>
              </template>

              <!-- Logo Section -->
              <template v-slot:append>
                <div class="d-flex align-center">
                  <img style="width: 80px; height: 40px; margin-right: 10px;" :src="require('@/img/company_logo/g-sfa.png')" />
                  <v-divider :thickness="3" vertical class="mb-0 mt-0 mr-3"></v-divider>
                  <img style="width: 220px; height: 70px;" :src="require('@/img/company_logo/logo-dark 2.png')" />
                </div>
              </template>

              <v-divider class="mt-2 mb-6 mr-4 ml-4"></v-divider>

              <v-card-subtitle class="mt-2">
                <div>
                  <v-icon size="small">mdi-account-arrow-right-outline</v-icon>
                  <span class="custom_paragraph_option_2">
                    We have sent an OTP code to your email,  <br>
                    <span class="countdown-text ml-6">{{ this.email }}</span>, for authentication.
                  </span>
                </div>
              </v-card-subtitle>

              <!-- OTP Inputs -->
              <v-card-text class="mt-4 text-center">
                <v-row justify="center">
                  <v-col v-for="(digit, index) in otp" :key="index" cols="2">
                    <v-text-field
                      v-model="otp[index]"
                      class="otp-input"
                      :class="{ 'error-field': otpFieldError }"
                      outlined
                      dense
                      single-line
                      type="text"
                      text-center
                      hide-details
                      ref="otpFields"
                      @input="moveToNext(index)"
                      :rules="[v => /^\d?$/.test(v) || 'Only one digit allowed']"
                      @keydown.delete="moveToPrevious(index)"
                      :disabled="isSubmitting"
                      @focus="clearOtpError"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row justify="center">
                  <v-col cols="auto">
                    <span class="countdown-text">
                      <span v-if="timeLeft > 0">
                        Try again in <strong>{{ formattedTime }}</strong>
                      </span>
                      <span v-else>
                        <span>Haven't received the email?</span>
                      </span>
                    </span>

                    <span v-if="timeLeft === 0">
                      <v-btn 
                        variant="text" 
                        class="resend-btn" 
                        @click="resendOtp"
                        :disabled="isResending"
                      >
                        <v-progress-circular v-if="isResending" size="20" indeterminate color="primary"></v-progress-circular>
                        <span v-else>RESEND</span>
                      </v-btn>
                    </span>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col sm="12" md="12" lg="12">
                    <v-divider></v-divider>
                  </v-col>

                  <v-col cols="12" sm="12" md="6">
                    <v-btn 
                      @click="submitOtp" 
                      size="x-large" 
                      block 
                      style="background-color: #800080; color: white;"
                      :disabled="isSubmitting"
                      :loading="isSubmitting"
                    >
                      <v-icon left>mdi mdi-account-arrow-right-outline</v-icon>
                      &nbsp;&nbsp;Continue
                    </v-btn>
                  </v-col>
                  
                  <v-col cols="12" sm="12" md="6">
                    <v-btn 
                      @click="backToLogIn" 
                      size="x-large" 
                      block 
                      class="custom_paragraph_option_btn_2"
                      :disabled="isSubmitting"
                    >
                      <v-icon left>mdi mdi-arrow-left</v-icon>
                      &nbsp;Back
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="2"></v-col>
        </v-row>
      </v-container>

      <v-snackbar
        v-model="snackAlert.snackbar"
        :color="snackAlert.snackColor"
        :right="snackAlert.snackBarRight"
        :top="snackAlert.snackBarTop"
        timeout="3000"
      >
        {{ snackAlert.snackMessage }}
      </v-snackbar>
    </v-main>
  </v-app>
</template>

<script>
import axios from 'axios';

export default {
  name: "OTPVerification",
  computed: {
    formattedTime() {
      const minutes = Math.floor(this.timeLeft / 60);
      const seconds = this.timeLeft % 60;
      return `${minutes.toString().padStart(2, '0')}m ${seconds.toString().padStart(2, '0')}s`;
    },
  },
  mounted() {
    this.startCountdown();
    const params = new URLSearchParams(window.location.search);
    this.email = params.get('email');
  },
  beforeUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  data() {
    return {
      otp: ["", "", "", ""],
      timeLeft: 60,
      centerLoading: false,
      isSubmitting: false,
      isResending: false,
      timer: null,
      otpFieldError: false,
      valid: false,
      drawer: null,
      email_errors: [],
      email: "",
      snackAlert: {
        snackbar: false,
        snackColor: "",
        snackMessage: "",
        snackBarRight: false,
        snackBarTop: true,
      },
    };
  },
  methods: {
    backToLogIn() {
      if (!this.isSubmitting) {
        this.$router.push('/forgot_password');
      }
    },
    
    showSnackbar(message, color) {
      this.snackAlert.snackMessage = message;
      this.snackAlert.snackColor = color;
      this.snackAlert.snackbar = true;
    },
    
    clearOtpError() {
      this.otpFieldError = false;
    },
    
    moveToNext(index) {
      // Clear error when user starts typing
      this.clearOtpError();
      
      // Only allow numbers (0-9) and limit input to 1 digit
      this.otp[index] = this.otp[index].replace(/\D/g, '').slice(0, 1);

      if (this.otp[index] && index < this.otp.length - 1) {
        const nextField = this.$refs.otpFields[index + 1]?.$el.querySelector("input");
        if (nextField) nextField.focus();
      }
    },
    
    moveToPrevious(index) {
      if (index > 0 && !this.otp[index]) {
        const prevField = this.$refs.otpFields[index - 1]?.$el.querySelector("input");
        if (prevField) prevField.focus();
      }
    },

    async submitOtp() {
      // Prevent multiple submissions
      if (this.isSubmitting) {
        return;
      }
      
      // Clear previous error
      this.clearOtpError();
      
      // Concatenate the digits in the otp array.
      const otpCode = this.otp.join('');

      // Basic check: ensure all 4 digits have been entered.
      if (otpCode.length !== 4) {
        this.otpFieldError = true;
        this.showSnackbar("Please enter a 4-digit OTP.", "error");
        return;
      }

      this.isSubmitting = true;
      this.centerLoading = true;

      try {
        const response = await axios.post('/api/web/verifyOtp', {
          email: this.email,
          otp: otpCode,
        });
        
        if (response.data.success) {
          this.showSnackbar(response.data.message, "success");
          window.location.href = `/reset-password?email=${encodeURIComponent(this.email)}`;
        } else {
          this.showSnackbar(response.data.message || "Invalid OTP", "error");
          this.isSubmitting = false;
        }
      } catch (error) {
        let errorMsg = "An error occurred. Please try again.";
        if (error.response && error.response.data && error.response.data.message) {
          errorMsg = error.response.data.message;
        }
        this.showSnackbar(errorMsg, "error");
        this.isSubmitting = false;
      } finally {
        this.centerLoading = false;
      }
    },

    startCountdown() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      
      this.timer = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--;
        } else {
          clearInterval(this.timer);
        }
      }, 1000);
    },

    startTimer() {
      this.timeLeft = 60;
      if (this.timer) clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--;
        } else {
          clearInterval(this.timer);
        }
      }, 1000);
    },

    async resendOtp() {
      if (this.isResending) {
        return;
      }
      
      this.isResending = true;
      this.centerLoading = true;
      
      try {
        const response = await axios.post('/api/resendOtp', { email: this.email });
        
        if (response.data.success) {
          this.showSnackbar(response.data.message, 'success');
          this.startTimer();
          this.otp = ['', '', '', ''];
          this.clearOtpError();
        } else {
          this.showSnackbar(response.data.message || 'Failed to resend OTP.', 'error');
        }
      } catch (error) {
        console.error('Resend OTP error:', error);
        let errorMsg = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          errorMsg = error.response.data.message;
        }
        this.showSnackbar(errorMsg, 'error');
      } finally {
        this.isResending = false;
        this.centerLoading = false;
      }
    },
  }
};
</script>

<style>
  @import "../../styles/auth/authentication.scss";
  
  /* Additional styles for loading states */
  .resend-btn {
    min-width: 80px;
  }
  
  .error-field input {
    border-color: #ff0000 !important;
  }
  
  .error-field .v-field__outline {
    border-color: #ff0000 !important;
  }
</style>